@if (items().length === 0) {
    <p class="empty">{{ emptyText() }}</p>
} @else {
    <ul class="tree">
        @for (item of items(); track item.ID) {
            @if (isVisible(item)) {
                <ng-container
                    [ngTemplateOutlet]="nodeTemplate"
                    [ngTemplateOutletContext]="{ $implicit: item }"
                />
            }
        }
    </ul>
}

<!-- Renders one node and, when expanded, recurses into its children through itself. -->
<ng-template #nodeTemplate let-item>
    <li class="select-tree-node">
        <div class="select-tree-row">
            @if (hasChildren(item)) {
                <!-- The item name is the accessible name; aria-expanded carries the state,
                     so no expand/collapse wording needs translating. -->
                <button
                    class="select-tree-toggle"
                    type="button"
                    [attr.aria-label]="item.Name"
                    [attr.aria-expanded]="isExpanded(item)"
                    (click)="toggleExpanded(item)"
                >
                    <mat-icon [svgIcon]="isExpanded(item) ? 'arrow-down' : 'arrow-right'" />
                </button>
            } @else {
                <span class="select-tree-toggle-spacer"></span>
            }

            @if (multiselect()) {
                <app-cerrix-checkbox
                    [value]="isSelected(item)"
                    [indeterminate]="isPartiallySelected(item)"
                    (valueChange)="toggleSelected(item)"
                >
                    <ng-container
                        [ngTemplateOutlet]="labelTemplate"
                        [ngTemplateOutletContext]="{ $implicit: item }"
                    />
                </app-cerrix-checkbox>
            } @else {
                <!-- One name across the whole tree, nesting included, makes every node part
                     of a single radio group — so only one of them can be picked. -->
                <app-cerrix-radio
                    [name]="radioGroupName"
                    [value]="isSelected(item)"
                    (valueChange)="toggleSelected(item)"
                >
                    <ng-container
                        [ngTemplateOutlet]="labelTemplate"
                        [ngTemplateOutletContext]="{ $implicit: item }"
                    />
                </app-cerrix-radio>
            }
        </div>

        @if (hasChildren(item) && isExpanded(item)) {
            <ul class="select-tree-children">
                @for (child of item.Children; track child.ID) {
                    @if (isVisible(child)) {
                        <ng-container
                            [ngTemplateOutlet]="nodeTemplate"
                            [ngTemplateOutletContext]="{ $implicit: child }"
                        />
                    }
                }
            </ul>
        }
    </li>
</ng-template>

<!-- The row label is the same whichever control carries it. -->
<ng-template #labelTemplate let-item>
    @if (item.Icon) {
        <app-cerrix-tree-icon-viewer
            [icon]="item.Icon"
            appendClass="fa-fw me-1"
        ></app-cerrix-tree-icon-viewer>
    } @else {
        <mat-icon class="select-tree-icon" [svgIcon]="iconPrefix()"></mat-icon>
    }
    <span class="select-tree-name">{{ item.Name }}</span>
</ng-template>
